import React from "react";
import Header from "components/Header/Header";
import TextSkeleton from "components/Skeletons/TextSkeleton/TextSkeleton";
import PropTypes from "prop-types";
import useCart from "hooks/useCart";
import { Link } from "react-router-dom";
import { CartIcon, VendingMachineIcon } from "constants/icons";
import { APP_ROUTES } from "constants/routes";
import "containers/Home/HomeHeader/HomeHeader.css";
import { connect } from "react-redux";

function HomeHeader({ vmName, clDetails }) {
  const { cartTotalQuantities } = useCart();
  return (
    <Header className="homepage__header">
      <div className="homepage__vending-machine-name__wrapper">
        <i>
          <img
            src={clDetails.logo_without_slogan}
            style={{
              marginTop: "-18px",
              width: "100px",
              height: "50px",
            }}
          />
        </i>
        {/* {vmName ? (
          <span className="homepage__vending-machine-name">{vmName}</span>
        ) : (
          <TextSkeleton />
        )} */}
      </div>
      <Link to={APP_ROUTES.CART_PAGE.url}>
        <i>
          <CartIcon />
        </i>
        {cartTotalQuantities !== 0 && (
          <span className="homepage__total-cart-items">
            {cartTotalQuantities}
          </span>
        )}
      </Link>
    </Header>
  );
}

HomeHeader.propTypes = {
  vmName: PropTypes.string,
};
const mapStateToProps = (state) => ({
  clDetails: state.clDetailsReducer,
});
const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(HomeHeader);
